import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    successDialog: {
    textAlign: 'center',
    padding: theme.spacing(3),
  },
  successIcon: {
    fontSize: '64px',
    color: '#4caf50',
    marginBottom: theme.spacing(2),
  },
}));

const SuccesDialog = ({ open, onClose, message }) => {
    const classes = useStyles();
    return (
        <>
        {/* Dialogue de succès avec proposition de téléchargement */}
                <Dialog
                  open={open}
                  onClose={onClose}
                  maxWidth="sm"
                  fullWidth
                >
                  <DialogTitle style={{ backgroundColor: '#4caf50', color: 'white', textAlign: 'center' }}>
                    Succès !
                  </DialogTitle>
                  <DialogContent className={classes.successDialog} dividers>
                    <CheckCircleIcon className={classes.successIcon} />
                    <Typography variant="h6" style={{ marginBottom: '16px', color: '#2e7d32' }}>
                      {message}
                    </Typography>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={onClose} color="primary" variant="contained">
                      Fermer
                    </Button>
                  </DialogActions>
                </Dialog>
        </>
    );
}

export default SuccesDialog;